var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMarkBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_558)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.839844 11.0318C0.839844 8.24068 1.94862 5.56386 3.92226 3.59022C5.89589 1.61659 8.57271 0.507813 11.3639 0.507812C14.155 0.507813 16.8318 1.61659 18.8055 3.59022C20.7791 5.56386 21.8879 8.24068 21.8879 11.0318C21.8879 13.823 20.7791 16.4998 18.8055 18.4734C16.8318 20.4471 14.155 21.5558 11.3639 21.5558C8.57271 21.5558 5.89589 20.4471 3.92226 18.4734C1.94862 16.4998 0.839844 13.823 0.839844 11.0318ZM10.7633 15.5361L16.8223 7.96162L15.7278 7.08602L10.5612 13.5421L6.90167 10.493L6.00362 11.5707L10.7633 15.5361Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.048,
    height: 21.048,
    fill: "white",
    transform: "translate(0.839844 0.507812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkBlack);
export default __webpack_public_path__ + "static/media/checkMarkBlack.61b2e9fd88516acdb1c5dc340569be41.svg";
export { ForwardRef as ReactComponent };